import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './posts.css'

export default class Posts extends Component {
    render() {
        return (
            <div className="posts col-lg-12">
                {this.props.posts.map((post, i) =>
                    <a href={post.url} target="_blank">
                        <div className="post" key={i}>
                            <img src={post.thumbnail} />
                            <span>{post.title}</span>
                        </div>
                    </a>)}
            </div>
        )
    }
}

Posts.propTypes = {
    posts: PropTypes.array.isRequired
}


// WEBPACK FOOTER //
// ./src/components/reddit/Posts.js